var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchStatusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33333 3.33333H13.3333",
    stroke: "#1E5AD2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33333 5.33333H11.3333",
    stroke: "#1E5AD2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 7.66667C14 11.1667 11.1667 14 7.66667 14C4.16667 14 1.33333 11.1667 1.33333 7.66667C1.33333 4.16667 4.16667 1.33333 7.66667 1.33333",
    stroke: "#1E5AD2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6667 14.6667L13.3333 13.3333",
    stroke: "#1E5AD2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStatusBlue);
export default __webpack_public_path__ + "static/media/search-status-blue.08d7139d7f8ba755dee6cf3efadec46e.svg";
export { ForwardRef as ReactComponent };